import { Component, OnInit, ViewContainerRef, OnDestroy } from "@angular/core";
import { utilityService } from "../../sharedcomponents/commonservice/utility.service";
import { SendMoneyService } from "../../_services/sendmoneyservice/sendmoneyservice";
import { TransactionHistoryService } from "../../_services/transaction/transaction-history.service";
import { mywalletcard } from "../../_services/mywallet/card/mywallet.card.service";
import { Modal, BSModalContext } from "angular2-modal/plugins/bootstrap";
import { overlayConfigFactory } from "angular2-modal";
import { GetReceiptComponent } from "../get-receipt/get-receipt.component";
import { uploaddocumtuserprofilestep1 } from "../../user/user-register/user-document-upload/userprofile-document-upload.component-Step1";
import { uploaddocumtuserprofilestep2 } from "../../user/user-register/user-document-upload/userprofile-document-upload.component-Step2";
import {
  AppSettings,
  enumStatusCodeList,
  OrderData
} from "../../sharedcomponents/_common/constants/app.constants";
import { Router } from "@angular/router";
import { PayagainFailedorderService } from "../../_services/transaction/payagain-failedorder.service";
import { AlertService } from "../../sharedcomponents/commonservice/alert.service";
import { InfoPopupComponent } from "../../sharedcomponents/_directive/info-popup/info-popup.component";
import { TranslateService } from "ng2-translate/ng2-translate";
import { DomSanitizer } from "@angular/platform-browser";
import { CartServiceService } from "../../_services/dashboardservice/cart/cart-service.service";
import { AlertPopupComponent } from "../../sharedcomponents/_directive/alert-popup/alert-popup.component";
import { geolocation } from "../../sharedcomponents/commonservice/geolocation/geoloc";
import { UserStateService } from "../../_services/userservice/userstateservice";
import { ShopingCart } from "app/models/dashboard/cart/mywallet.currentcart.Modal";
import { taxDetail } from "app/models/sendmoney/sendmoney";
import { ErrorPopupComponent } from "app/sharedcomponents/_directive/error-popup/error-popup.component";
@Component({
  selector: "app-transaction-list-user-detail",
  templateUrl: "./transaction-list-user-detail.component.html",
  styleUrls: ["./transaction-list-user-detail.component.css"],
  providers: [mywalletcard, Modal, AlertService, CartServiceService]
})
export class TransactionListUserDetailComponent implements OnInit, OnDestroy {
  userTranscationdetail: any = [];
  agentImgData = "";
  branchImageData = "";
  orderID: string;
  appSettings: any;
  pickupType: string;
  IsRedBGColored: string;
  cancelOrDelete: string;
  cancelTrans = false;
  GetReceipt = false;
  PayAgain = false;
  UploadDocument = false;
  repeatOrder = false;
  currentStatus: string;
  documentrequireCurrentStatus: string;
  cardNumber: string = "";
  iscardNumber = false;
  cardFriendlyName = "";
  storeName;
  img: any = {};
  destCountryImage: any;
  benificaryData;
  transPinNumber;
  taxAmount: number;
  taxDetails: taxDetail[];
  // shareCredit = 0;
  subgettransbenifcaryDetailData;
  transData: any;
  buttonClass;
  userDetail: any = {};
  disclaimers = "";
  OrderList = [];
  OrderStatusList: any = {};
  constructor(
    public utilserv: utilityService,
    public smService: SendMoneyService,
    private cardservice: mywalletcard,
    public modal: Modal,
    private router: Router,
    public transHistory: TransactionHistoryService,
    public payeagainservice: PayagainFailedorderService,
    private alertService: AlertService,
    private translate: TranslateService,
    public domSanitizer: DomSanitizer,
    private cartservice: CartServiceService,
    private vcRef: ViewContainerRef,
    public geoloc: geolocation,
    private userStateService: UserStateService
  ) {
    // Service 2 Transcation Data
    this.subgettransbenifcaryDetailData = this.transHistory
      .gettransbenifcaryDetailData()
      .subscribe(data => {
        this.transData = data;
        this.userTranscationdetail = this.utilserv.getArray(this.transData)[0];
        this.initiliazeVariable(this.transData);
        this.benificaryData = this.utilserv.getArray(this.transData);
        this.setButtonState(this.currentStatus);

        if (this.utilserv.getObjectText(this.transData.DeliveryMethod) == "2") {
          this.utilserv.busy = this.smService
            .getBankLogo(this.img)
            .subscribe(data => {
              // if (this.currentStatus != 'PMT_FAILED') {
              this.OrderList = new Array<ShopingCart>();
              let item = this.utilserv.getObjectText(
                this.userTranscationdetail.OriginalItemId
              );
              if (item == "") {
                item = this.utilserv.getObjectText(
                  this.userTranscationdetail.OrderNumber
                );
              }

              this.OrderList.push(item);
              this.getOrderStatus();
              this.getTransactionDetailV2();
              // } else {
              //   this.OrderStatusList = {};
              // }

              if (data.HasDefaultImage == true) {
                this.agentImgData = "";
              } else {
                this.agentImgData =
                  "data:image/gif;base64," + data.BankImageData;
              }
            });
        } else {
          this.utilserv.busy = this.smService
            .getPayerLogo(this.img)
            .subscribe(data => {
              // if (this.currentStatus != 'PMT_FAILED') {
              this.OrderList = new Array<ShopingCart>();

              let item = this.utilserv.getObjectText(
                this.userTranscationdetail.OriginalItemId
              );
              if (item == "") {
                item = this.utilserv.getObjectText(
                  this.userTranscationdetail.OrderNumber
                );
              }
              this.OrderList.push(item);
              this.getOrderStatus();
              this.getTransactionDetailV2();
              // } else {
              //   this.OrderStatusList = {};
              // }

              if (data.HasDefaultImage == true) {
                this.agentImgData = "";
              } else {
                this.agentImgData =
                  "data:image/gif;base64," + data.PayingAgentImageData;
              }
            });
        }

        // Service 3 For Getting agent Image

        // Service 4 For Getting branch Image
        this.getBranchLogo(this.img);
        // Service 5 For Getting Country image file
        // this.loadCountryImageFile();
        // Service 6 For Getting Disclaimer
        //  this.getDisclaimer();
        // Service 7 For Getting Disclaimer
      });
  }

  ngOnInit() {
    this.appSettings = AppSettings;
    // Service 1 For Getting user data
    this.userStateService.getcurrentUserDetailData().subscribe(data => {
      this.userDetail = data;
    });
  }

  initiliazeVariable(benificaryDetailCollection) {
    this.cancelTrans = false;
    this.GetReceipt = false;
    this.PayAgain = false;
    this.UploadDocument = false;
    this.repeatOrder = false;
    this.cancelOrDelete = this.translate.instant("TransactionDetail_btnCancel");
    this.orderID = this.utilserv.getObjectText(
      benificaryDetailCollection.OrderNumber
    );
    this.pickupType = this.utilserv.getObjectText(
      benificaryDetailCollection.DeliveryMethod
    );
    this.IsRedBGColored = this.utilserv.getObjectText(
      benificaryDetailCollection.IsRedBGColored
    );
    this.img.PayingAgentId = this.utilserv.getObjectText(
      benificaryDetailCollection.PayingAgentId
    );
    this.img.LocationId = this.utilserv.getObjectText(
      benificaryDetailCollection.PayingAgentLocationId
    );

    this.img.BankId = this.utilserv.getObjectText(
      benificaryDetailCollection.BankId
    );
    this.img.BankName = this.utilserv.getObjectText(
      benificaryDetailCollection.BankName
    );

    if (
      (this.utilserv.getObjectText(
        benificaryDetailCollection.RequireCustomerID
      ) == "true" ||
        this.utilserv.getObjectText(
          benificaryDetailCollection.RequireCustomerTaxID
        ) == "true" ||
        this.utilserv.getObjectText(
          benificaryDetailCollection.RequireCustomerTaxIdForUSID
        ) == "true") &&
      this.utilserv
        .getObjectText(benificaryDetailCollection.Current)
        .toUpperCase() == "PMT_PENDING"
    ) {
      this.documentrequireCurrentStatus = this.utilserv
        .getObjectText(benificaryDetailCollection.Current)
        .toUpperCase();
      this.currentStatus = "PMT_STATUS_DOC_REQUIRED";
    } else {
      this.currentStatus = this.utilserv
        .getObjectText(benificaryDetailCollection.Current)
        .toUpperCase();
    }
  }

  loadCountryImageFile() {
    this.utilserv
      .getCountryImage(this.userTranscationdetail.CountryCodeTo)
      .subscribe(
        res => {
          this.destCountryImage = res;
        },
        error => {
          console.log(error);
        }
      );
  }

  getBranchLogo(pc) {
    if (pc.PayingAgentLocationId != "") {
      this.utilserv.busy = this.smService.getBranchImage(pc).subscribe(
        data => {
          if (data.HasDefaultImage == true) {
            this.branchImageData = "";
          } else {
            this.branchImageData =
              "data:image/gif;base64," + data.BranchImageData;
          }
        },
        error => {
          console.log("Unable to fetch Branch Image" + error);
        }
      );
    }
  }

  showusertranscation(benificaryDetail) {
    if (this.utilserv.getObjectText(benificaryDetail.FundingId) != "") {
      this.getcardlist(benificaryDetail);
    } else {
      this.utilserv.busy = this.geoloc.getGioLocation().subscribe(data => {
        const userGioLocation: any = data;
        this.utilserv.busy = this.smService
          .loadStoresInMap(true, userGioLocation)
          .subscribe(data => {
            const resJSON = data;
            this.cardFriendlyName = this.translate.instant(
              "Common_lblPayStore"
            ); // Store Payment Label
            if (
              resJSON.Envelope.Body.StoresResponse.StatusCode ==
              enumStatusCodeList.SUCCESS
            ) {
              const tempStoreCollection = this.utilserv.getArray(
                resJSON.Envelope.Body.StoresResponse.Stores.StoreDetail
              );
              this.storeName = tempStoreCollection.filter(
                storeDetail =>
                  storeDetail.StoreID ==
                  this.utilserv.getObjectText(benificaryDetail.ReceivingAgentId)
              );
            }
            if (this.storeName == "" || this.storeName == undefined) {
              this.cardFriendlyName = "";
            }
          });
      });
    }
  }

  getcardlist(benificaryDetail) {
    this.utilserv.busy = this.cardservice
      .getcardlistservice(
        this.utilserv.getObjectText(benificaryDetail.FundingId)
      )
      .subscribe(data => {
        // Intialize Image
        if (
          data.Envelope.Body.GetFundingResponse.StatusCode ==
          enumStatusCodeList.SUCCESS
        ) {
          const cardList = this.utilserv.getArray(
            data.Envelope.Body.GetFundingResponse.Fundings.Funding
          );
          if (cardList.length > 0 && cardList[0] != undefined) {
            this.iscardNumber = true;
            this.cardNumber =
              "xxxx-xxxx-xxxx-" +
              this.utilserv.getObjectText(cardList[0].AccountNumber);
            this.cardFriendlyName = this.utilserv.getObjectText(
              cardList[0].FriendlyName
            );
          } else {
            this.iscardNumber = false;
            this.cardNumber = this.translate.instant(
              "PaymentReceiptDetail_lblCardRemoved"
            );
          }
          // Service 4 For Getting Transcation Pin
          // this.getTransPin(benificaryDetail);
        }
      });
  }
  // private getTransPin(benificaryDetail) {
  //   this.getTransPinService(this.utilserv.getObjectText(benificaryDetail.OrderNumber));
  // }
  // private getTransPinService(orderid: any) {
  //   this.utilserv.busy = this.transHistory.gettransactionlPin(orderid).subscribe(
  //     transPinDatadata => {
  //       if (transPinDatadata.Envelope.Body.PINResponse.StatusCode == enumStatusCodeList.SUCCESS) {
  //         this.transPinNumber = this.utilserv.getObjectText(transPinDatadata.Envelope.Body.PINResponse.Pin);
  //       } else {
  //         this.transPinNumber = '';
  //       }

  //     },
  //     error => {
  //       console.log('Something went wrong!!!, Unable to get pin transcation history' + error);
  //     }
  //   );
  // }
  getreceipt() {
    return this.modal.open(
      GetReceiptComponent,
      overlayConfigFactory({ orderdid: this.orderID }, BSModalContext)
    );
  }

  canceltranscation() {
    switch (this.currentStatus) {
      case "PMT_FAILED": {
        this.deleteitemfromcartforCanceltrans(this.orderID);
        break;
      }
      case "PMT_STATUS_DOC_REQUIRED": {
        if (this.documentrequireCurrentStatus == "PMT_FAILED") {
          this.deleteitemfromcartforCanceltrans(this.orderID);
        } else {
          this.canceltranscationcommon();
        }
        break;
      }
      case "PMT_PENDING": {
        if (
          this.utilserv.getObjectText(
            this.benificaryData[0].PaidAtReceivingAgentId
          ) != "0" ||
          this.utilserv.getObjectText(this.benificaryData[0].FundingId) != ""
        ) {
          // this.deleteitemfromcartforCanceltrans(this.orderID);
          this.canceltranscationcommon();
        }
        break;
      }
      case "PMT_CMPLTD": {
        this.canceltranscationcommon();
        break;
      }
      default: {
        break;
      }
    }
  }
  deleteitemfromcartforCanceltrans(shoppingCartOrderID) {
    this.modal.overlay.defaultViewContainer = this.vcRef;
    const _self = this;
    const modalData: any = {};
    const path = _self.router.url.split("/")[1];
    modalData.Title = this.translate.instant("Common_lblConfirm");
    modalData.Message = _self.translate.instant("DeleteCartItemPopup_desc");
    return _self.modal
      .open(
        InfoPopupComponent,
        overlayConfigFactory({ modalData }, BSModalContext)
      )
      .then(function (obj) {
        obj.onDestroy.subscribe(data => {
          console.log("Observer got a next value: " + data);
          if (modalData.next == "yes") {
            _self.utilserv.busy = _self.cartservice
              .deletetransitem(
                _self.utilserv.getObjectText(shoppingCartOrderID)
              )
              .subscribe(
                canceldata => {
                  try {
                    if (canceldata.StatusCode == enumStatusCodeList.SUCCESS) {
                      // _self.ngOnInit();
                      if (path == "transactionuserlist") {
                        _self.router.navigate(["/transactionuserlists"]);
                      } else {
                        _self.router.navigate(["/transactionuserlist"]);
                      }
                    } else {
                      _self.alertService.openErrorAlert(
                        _self.translate.instant("Common_lblOops"),
                        canceldata.Envelope.Body.ResponseBase.StatusMessage
                      );
                    }
                  } catch (ex) {
                    console.log(
                      "Something went wrong,Unable to delte cart Item"
                    );
                  }
                },
                error => {
                  console.log(
                    "Something went wrong,Unable to delte cart Item" + error
                  );
                }
              );
          }
        });
      });
  }

  canceltranscationcommon() {
    this.modal.overlay.defaultViewContainer = this.vcRef;
    const _self = this;
    const modalData: any = {};
    const path = _self.router.url.split("/")[1];
    modalData.Title = this.translate.instant("Common_lblConfirm");
    modalData.Message = _self.translate.instant("CancelTransactionPopup_desc");
    return _self.modal
      .open(
        InfoPopupComponent,
        overlayConfigFactory({ modalData }, BSModalContext)
      )
      .then(function (obj) {
        obj.onDestroy.subscribe(data => {
          console.log("Observer got a next value: " + data);
          if (modalData.next == "yes") {
            _self.utilserv.busy = _self.transHistory
              .cancelorderservice(_self.orderID)
              .subscribe(
                canceldata => {
                  try {
                    if (
                      canceldata.Envelope.Body.ResponseBase.StatusCode ==
                      enumStatusCodeList.SUCCESS
                    ) {
                      // _self.ngOnInit();
                      if (path == "transactionuserlist") {
                        _self.router.navigate(["/transactionuserlists"]);
                      } else {
                        _self.router.navigate(["/transactionuserlist"]);
                      }
                    } else {
                      _self.alertService.openErrorAlert(
                        _self.translate.instant("Common_lblOops"),
                        canceldata.Envelope.Body.ResponseBase.StatusMessage
                      );
                    }
                  } catch (ex) {
                    console.log(
                      "Something went wrong,Unable to delte cart Item"
                    );
                  }
                },
                error => {
                  console.log(
                    "Something went wrong,Unable to delte cart Item" + error
                  );
                }
              );
          }
        });
      });
  }
  uploadDocument() {
    const parent = this;
    const DocumentRequired: any = {};
    const modalData: any = {};
    DocumentRequired.RequireCustomerID =
      this.utilserv.getObjectText(this.benificaryData[0].RequireCustomerID) ==
        "true"
        ? true
        : false;
    DocumentRequired.RequireCustomerTaxID =
      this.utilserv.getObjectText(
        this.benificaryData[0].RequireCustomerTaxID
      ) == "true"
        ? true
        : false;
    DocumentRequired.RequireCustomerTaxIdForUSID =
      this.utilserv.getObjectText(
        this.benificaryData[0].RequireCustomerTaxIdForUSID
      ) == "true"
        ? true
        : false;
    modalData.DocumentRequired = DocumentRequired;
    this.modal.overlay.defaultViewContainer = this.vcRef;
    return this.modal
      .open(
        uploaddocumtuserprofilestep1,
        overlayConfigFactory({ modalData }, BSModalContext)
      )
      .then(function (obj) {
        obj.onDestroy.subscribe(data => {
          if (modalData.Status == false) {
            return;
          }
          console.log("Observer got a next value: " + data);
          if (modalData.Status == true) {
            parent.opendocstep2(modalData);
          }
        });
      });
  }

  opendocstep2(modalData) {
    const _self = this;
    const path = _self.router.url.split("/")[1];
    modalData.Status = false;
    this.modal.overlay.defaultViewContainer = this.vcRef;
    return this.modal
      .open(
        uploaddocumtuserprofilestep2,
        overlayConfigFactory({ modalData }, BSModalContext)
      )
      .then(function (obj) {
        obj.onDestroy.subscribe(data => {
          console.log("Observer got a next value: " + data);
          if (modalData.Status == false) {
            return;
          }
          if (modalData.Status == true) {
            // parent.ngOnInit();
            if (path == "transactionuserlist") {
              _self.router.navigate(["/transactionuserlists"]);
            } else {
              _self.router.navigate(["/transactionuserlist"]);
            }
          } else {
          }
        });
      });
  }
  payagain() {
    this.payeagainservice.setfailtransbenifcaryDetailData(
      this.userTranscationdetail
    );
    this.router.navigate(["/payagaintrans"]);
    return;
  }
  repeatOrderclick() {
    this.utilserv.busy = this.geoloc.islocPermissionable().subscribe(data => {
      const _self = this;
      if (data == undefined) {
        return;
      }

      if (data == true) {
        const orderData: OrderData = new OrderData();
        orderData.BenificiaryId = _self.utilserv.getObjectText(
          this.userTranscationdetail.beneficiaryuserDetail.BeneficiaryId
        );
        orderData.OrderNo = _self.utilserv.getObjectText(
          this.userTranscationdetail.OrderNumber
        );
        sessionStorage.orderData = JSON.stringify(orderData);
        // this.payeagainservice.setbeneficiaryforRepeatOrder(this.userTranscationdetail);
        // this.smService.setRepeatOrderFlow('repeatorderlisttrans');
        // this.router.navigate(['/repeatorderlisttrans']);
        this.router.navigate(["/repeatorderlist"]);
        return;
      } else {
        let modalData: any = {};
        modalData.Action = this.translate.instant("Common_lblOk");
        modalData.Title = this.translate.instant("Common_lblInfo").toString();
        modalData.Message = this.translate
          .instant("Common_lblLocationValidate")
          .toString();
        this.modal.overlay.defaultViewContainer = this.vcRef;
        return this.modal
          .open(
            AlertPopupComponent,
            overlayConfigFactory({ modalData }, BSModalContext)
          )
          .then(function (obj) {
            obj.onDestroy.subscribe(data => {
              console.log("Observer got a next value: " + data);
              const orderData: OrderData = new OrderData();
              orderData.BenificiaryId = _self.utilserv.getObjectText(
                _self.userTranscationdetail.beneficiaryuserDetail.BeneficiaryId
              );
              orderData.OrderNo = _self.utilserv.getObjectText(
                _self.userTranscationdetail.OrderNumber
              );
              sessionStorage.orderData = JSON.stringify(orderData);
              // _self.payeagainservice.setbeneficiaryforRepeatOrder(_self.userTranscationdetail);
              // _self.smService.setRepeatOrderFlow('repeatorderlisttrans');
              // _self.router.navigate(['/repeatorderlisttrans']);
              _self.router.navigate(["/repeatorderlist"]);
              return;
            });
          });
      }
    });
  }

  // Button State on the basis of states
  setButtonState(btranscationStatus) {
    switch (btranscationStatus) {
      case "PMT_FAILED": {
        // Payment Failed
        this.cancelOrDelete = this.translate.instant(
          "Common_lblDeleteTransaction"
        );

        this.cancelTrans = true;
        this.GetReceipt = true;
        this.PayAgain = true;
        this.buttonClass = "button_section_trans_historyDR";
        break;
      }
      case "PMT_STATUS_DOC_REQUIRED": {
        // Document required
        this.cancelTrans = true;
        this.GetReceipt = true;
        this.UploadDocument = true;
        this.buttonClass = "button_section_trans_historyDR";
        if (this.documentrequireCurrentStatus == "PMT_FAILED") {
          this.cancelOrDelete = this.translate.instant(
            "Common_lblDeleteTransaction"
          );
        }
        break;
      }
      case "PMT_PENDING": {
        // Pending Funding
        this.cancelTrans = true;
        this.GetReceipt = true;
        this.buttonClass = "button_section_trans_history";
        if (
          (this.utilserv.getObjectText(
            this.benificaryData[0].PaidAtReceivingAgentId
          ) == "0" ||
            this.utilserv.getObjectText(
              this.benificaryData[0].PaidAtReceivingAgentId
            ) == "") &&
          this.utilserv.getObjectText(this.benificaryData[0].FundingId) == ""
        ) {
          // Disable cancel transcation
          // this.disablePending = false ;
          this.cancelTrans = false;
          this.GetReceipt = false;
        }
        break;
      }
      case "PMT_CMPLTD": {
        //Completed /Paid
        this.cancelTrans = true;
        this.GetReceipt = true;
        this.repeatOrder = true;
        this.buttonClass = "button_section_trans_history";
        break;
      }
      case "PMT_PAID": {
        //Completed /Paid
        this.GetReceipt = true;
        this.repeatOrder = true;
        this.buttonClass = "button_section_trans_history";
        break;
      }

      case "PMT_CNCLD": {
        // Cancel,Cancellation Pending
        // this.GetReceipt = true;
        // this.buttonClass = 'button0';
        break;
      }
      case "PMT_PAID_TransationHistory": {
        this.GetReceipt = true;
        this.repeatOrder = true;
        this.buttonClass = "button_section_trans_history";
        break;
      }

      default: {
        break;
      }
    }
  }
  getDisclaimer() {
    this.utilserv.busy = this.smService.getDisclaimerDetails().subscribe(
      data => {
        if (data.StatusCode == enumStatusCodeList.SUCCESS) {
          try {
            let josnObj: any = data.CountriesDisclaimer;
            let contryObj = josnObj.filter(
              country => country.CountryCode === this.userDetail.country
            )[0].States;
            let disclaimerLines = contryObj.filter(
              state => state.StateCode === this.userDetail.state
            );
            this.disclaimers = disclaimerLines[0].Lines.map(line => line).join(
              " "
            );
          } catch (error) { }
        }
      },
      error => {
        console.log("Unable to fetch DisclaimerDetails" + error);
      }
    );
  }
  getOrderStatus() {
    //console.log("LA data para traer el item status", this.userTranscationdetail.beneficiaryuserDetail.BeneficiaryId, this.orderID)
    this.utilserv.busy = this.transHistory
      .getOrderItemStatus(this.OrderList)
      .subscribe(
        data => {
          this.showusertranscation(this.userTranscationdetail);
          if (
            data.Envelope.Body.OrderStatusResponse.StatusCode ==
            enumStatusCodeList.SUCCESS
          ) {
            this.OrderStatusList = this.utilserv.getArray(
              data.Envelope.Body.OrderStatusResponse.OrdersStatus
                .CartOrderStatus
            )[0];
          }
        },
        error => {
          console.log("Unable to getOrderStatus" + error);
        }
      );
  }


  mapTaxDetails(taxDetails: any): taxDetail[] {
  if (!taxDetails || !taxDetails.Tax) return [];
  
  // Si Tax es un array, mapeamos todos los elementos
  if (Array.isArray(taxDetails.Tax)) {
    return taxDetails.Tax.map((tax: any) => ({
      Amount: parseFloat(tax.Amount.__text),
      Description: tax.Description.__text,
      Name: tax.Name.__text
    }));
  }
  
  // Si Tax es un solo objeto, lo convertimos a array
  return [{
    Amount: parseFloat(taxDetails.Tax.Amount.__text),
    Description: taxDetails.Tax.Description.__text,
    Name: taxDetails.Tax.Name.__text
  }];
}

   getTransactionDetailV2() {
    //console.log("LA data para traer el item status", this.userTranscationdetail.beneficiaryuserDetail.BeneficiaryId.__text, this.orderID)
    this.utilserv.busy = this.transHistory
      .getTransferDetailV2Service(this.orderID, this.userTranscationdetail.beneficiaryuserDetail.BeneficiaryId.__text)
      .subscribe(
        data => {
          //console.log("LA data ahora si del V2", data.Envelope)
          if (
            data.Envelope.Body.TransactionDetailsResponse.StatusCode ==
            enumStatusCodeList.SUCCESS
          ) { 
            this.taxAmount = data.Envelope.Body.TransactionDetailsResponse.TaxAmount;
            const taxDetailsArray: taxDetail[] = this.mapTaxDetails(data.Envelope.Body.TransactionDetailsResponse.TaxDetails);
            this.taxDetails = taxDetailsArray;
            //console.log("LA data ahora si del V2", data.Envelope)
            //console.log("el tax Details", this.taxDetails)
          }
        },
        error => {
          console.log("Unable to getOrderStatus" + error);
        }
      );
  }



  openTaxesDetail() {
      //console.log("Hola m")
      let modalData: any = {};
      modalData.Title = this.translate.instant('Common_lblTaxDetails');
      modalData.Message = "";
  
      if (this.taxDetails == null || this.taxDetails.length === 0) {
          modalData.Message = this.translate.instant('Common_lblNoTax'); 
      } else {
          // Mapear cada elemento del array a una cadena con el formato "Name: $Amount"
          const taxMessages = this.taxDetails.map(tax => {
              return `${tax.Name}: $${tax.Amount.toFixed(2)}`; // toFixed(2) para mostrar 2 decimales
          });
          
          // Unir todos los mensajes con <br> como separador
          modalData.Message = taxMessages.join('<br>');
      }
      this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
    }

  ngOnDestroy() {
    if (this.subgettransbenifcaryDetailData != undefined) {
      this.subgettransbenifcaryDetailData.unsubscribe();
    }
  }
  setButtonClasses() { }
}



// WEBPACK FOOTER //
// ./src/app/transaction-history/transaction-list-user-detail/transaction-list-user-detail.component.ts